module.exports = __webpack_public_path__ + "img/psicologia-positiva-1.be5966b3.jpg";